

import {
    PageHeader,
    Spin,
    Select,
    Row,
    Col,
    message,
    Popconfirm,
    Space,
    Tag,
  } from "antd";
  import axios from "axios";
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import {
    Form,
    FormItem,
    SelectItem,
    InputNumberItem,
    InputItem,
    NotificacionPolizas,
    NotificacionMovimientosInventario,
    ButtonItem,
    SelectInsumosItem,
    DynamicCardForm,
    TabbedDynamicTable,
    dineroDisabledMask,
  } from "../../../../Components/Items";
 import { FilePdfOutlined, LockOutlined, UnlockOutlined } from "@ant-design/icons";
 import ModalProductosAlCostoPdf from "../ModalProductosAlCostoPdf/ModalProductosAlCostoPdf";
 import ModalApartarProductosAlCosto from "../ModalApartarProductosAlCosto/ModalApartarProductosAlCosto";
  
  const { Option } = Select;
  
  class VerOrdenProductosAlCosto extends Component {
    formRef = React.createRef();
    state = {
      loading: false,
      objetoProyectos: null,
      todasProyectos: null,
      todasInsumos: [],
      objetoInsumos: null,
      modalAgregarCuentaContable: false,
      numOrden: 0,
      estadoOrden: 0,
      ordenApartada: false,
      modalPdfVisible: false,
      modalApartarVisible: false,
      modalApartarModo: 'apartar',
    };
    componentDidMount() {
      this.consultarTodo();
    }
    async consultarTodo() {
      this.setState({ loading: true });
      await axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasProyectos: res.data });
            this.setState({
              objetoProyectos: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
        await axios
        .post(
          "productosAlCosto/datosOrdenProductosAlCosto",
          {
            empresaId: this.props.empresaId,
            ordenId: this.props.location.state.id,
          },
          { headers: this.props.headersToken }
        )
        .then(async (res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasInsumos: res.data.insumosCatalogo || [] });

            let insumosConCantidad = res.data.insumos;
            if (res.data.insumos.length > 0) {
              const insumosBulkPayload = res.data.insumos.map((insumo, index) => ({
                index,
                insumoId: insumo.insumoId,
                proyectoId: res.data.proyectoId,
                inventariable: true,
              }));
              try {
                const resInventarios = await axios.post(
                  "inventarios/inventarioInsumoProyectoBulk",
                  {
                    empresaId: this.props.empresaId,
                    proyectoId: res.data.proyectoId,
                    insumos: insumosBulkPayload,
                  },
                  { headers: this.props.headersToken }
                );
                insumosConCantidad = res.data.insumos.map((insumo, index) => {
                  const resultado = resInventarios.data?.results?.find((r) => r.index === index);
                  return { ...insumo, cantidadProyecto: resultado?.cantidad ?? 0 };
                });
              } catch (error) {
                console.error("Error al consultar inventario", error);
              }
            }

            await this.formRef.current.setFieldsValue({ ...res.data, insumos: insumosConCantidad });
            await this.setState({
              numOrden: res.data.numero,
              estadoOrden: res.data.estado,
              ordenApartada: !!res.data.apartado,
            });
          }
        });
      this.setState({ loading: false });
    }
    atras() {
      this.props.history.goBack();
    }
    renderTagEstado() {
      if (this.state.estadoOrden === 0) {
        return <Tag color="red" className="square-tag">Cancelada</Tag>;
      }
      if (this.state.estadoOrden === 1) {
        return (
          <Space>
            <Tag color="blue" className="square-tag">Por confirmar</Tag>
            {this.state.ordenApartada && <Tag color="gold" className="square-tag">Apartada</Tag>}
          </Space>
        );
      }
      if (this.state.estadoOrden === 3) {
        return <Tag color="green" className="square-tag">Agregada</Tag>;
      }
      return null;
    }
    abrirModalApartar(modo) {
      this.setState({ modalApartarVisible: true, modalApartarModo: modo });
    }
    cerrarModalApartar(seMovioInventario) {
      this.setState({ modalApartarVisible: false });
      if (seMovioInventario) {
        this.consultarTodo();
      }
    }
    async onChangeInsumo(value, key, insumoEncontrado) {
      let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let proyecto = await this.formRef.current.getFieldValue("proyectoId");
        this.setState({ loading: true });
        const insumoId = arrayValue[key].insumoId;
        let insumo
        if (insumoEncontrado) {
          insumo = insumoEncontrado;
          const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
          if (!yaExiste) {
            await this.setState(prev => ({
              todasInsumos: [...prev.todasInsumos, insumo]
            }));
          }
        } else {
          insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === insumoId
          );
        }
        this.setState({ loading: false });
        if(!insumo) return
          await axios
            .post(
              "inventarios/inventarioInsumoProyecto",
              {
                proyectoId: proyecto,
                insumoId: insumoId,
                empresaId: this.props.empresaId,
              },
              { headers: this.props.headersToken }
            )
            .then((res) => {
              this.setState({ loading: false });
              arrayValue[key].cantidadProyecto = res.data.cantidad;
            });
        this.formRef.current.setFieldsValue({
          insumos: arrayValue,
        });
      }
      confirmarProductosAlCosto() {
        axios
          .post(
            "productosAlCosto/confirmarOrdenProductosAlCosto",
            {
              ordenId: this.props.location.state.id,
              empresaId: this.props.empresaId,
            },
            { headers: this.props.headersToken }
          )
          .then((res) => {
            this.setState({ loading: false });
            if (res.data.success === 2) {
              message.success(
                "Se mandaron los productos al costo"
              );
              NotificacionPolizas(res.data.polizasId)
              NotificacionMovimientosInventario(res.data.movimientosIds)
            } else if (res.data.success === 1) {
              message.error(res.data.message ? res.data.message : "No hay suficiente inventario");
            } else {
              message.error("Hubo un error y el inventario no se redujo");
            }
            this.consultarTodo();
          });
      }
    
      cancelarOrdenProductosAlCosto() {
        axios
          .post(
            "productosAlCosto/cancelarOrdenProductosAlCosto",
            {
              ordenId: this.props.location.state.id,
              empresaId: this.props.empresaId,
            },
            { headers: this.props.headersToken }
          )
          .then((res) => {
            if (res.data.success === 2) {
                message.success("Orden cancelada");
              } else {
                message.error(res.data.message ? res.data.message : "Sucedio un error y no se pudo cancelar");
              }
              this.consultarTodo();
          });
      }

      toggleModalPdf = () => {
        this.setState({ modalPdfVisible: !this.state.modalPdfVisible });
      };

    render() {
      const isMobile = window.innerWidth <= 1000;

      const ordenConfirmada = this.state.estadoOrden === 3;
      const mostrarApartado = this.state.ordenApartada && !ordenConfirmada;

      const columnasInsumos = [
        { title: 'Insumo', width: ordenConfirmada ? '50%' : (mostrarApartado ? '46%' : '60%') },
        { title: 'Cantidad Proyecto', width: ordenConfirmada ? '17%' : (mostrarApartado ? '18%' : '20%') },
        { title: 'Cantidad', width: ordenConfirmada ? '17%' : (mostrarApartado ? '18%' : '20%') },
      ];
      if (mostrarApartado) {
        columnasInsumos.push({ title: 'Apartado', width: '18%' });
      }
      if (ordenConfirmada) {
        columnasInsumos.push({ title: 'Costo', width: '16%' });
      }

      const allTabs = [
        {
          key: 'insumos',
          label: 'Insumos',
          listName: 'insumos',
          columns: columnasInsumos,
          renderRow: ({ key, name, restField, arrayKey }) => {
            const insumoId = this.formRef.current?.getFieldValue(['insumos', arrayKey, 'insumoId']);
            const insumoPreCargado = this.state.todasInsumos?.find(
              (insumo) => insumo._id.toString() === insumoId?.toString()
            );
            const costoInsumo = this.formRef.current?.getFieldValue(['insumos', arrayKey, 'costo']);
            const apartadoInsumo = this.formRef.current?.getFieldValue(['insumos', arrayKey, 'apartado']);
            return (
            <React.Fragment key={key}>
              <tr>
                <td className="td-border">
                  <FormItem
                    {...restField}
                    name={[name, "insumoId"]}
                    fieldKey={[arrayKey, "insumoId"]}
                    required
                    noStyle
                  >
                    <SelectInsumosItem
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                      sinBorde
                      autoFocus
                      dropdownMatchSelectWidth={600}
                      width="100%"
                      placeholder="Insumo"
                      tiposInsumos="inventariables"
                      disabled
                      onChange={(value, insumoEncontrado) =>
                        this.onChangeInsumo(
                          value,
                          arrayKey,
                          insumoEncontrado
                        )
                      }
                      insumoPreCargado={insumoPreCargado}
                    />
                  </FormItem>
                </td>
                <td className="td-border">
                  <FormItem
                    {...restField}
                    name={[name, "cantidadProyecto"]}
                    fieldKey={[arrayKey, "cantidadProyecto"]}
                    number
                    noStyle
                    disabled
                    required
                    initialValue={undefined}
                  >
                    <InputNumberItem sinBorde disabled/>
                  </FormItem>
                </td>
                <td className="td-border">
                  <FormItem
                    {...restField}
                    name={[name, "cantidad"]}
                    fieldKey={[arrayKey, "cantidad"]}
                    number
                    noStyle
                    required
                    disabled
                    type='number'
                    initialValue={undefined}
                  >
                    <InputNumberItem sinBorde disabled />
                  </FormItem>
                </td>
                {mostrarApartado && (
                  <td className="td-border" style={{ textAlign: 'center' }}>
                    {Number(apartadoInsumo) || 0}
                  </td>
                )}
                {ordenConfirmada && (
                  <td className="td-border" style={{ textAlign: 'right' }}>
                    {dineroDisabledMask(costoInsumo || 0)}
                  </td>
                )}
              </tr>
            </React.Fragment>
            );
          },
        },
      ];

      return (
        <>
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Ver Orden - Productos al costo"
            extra={this.renderTagEstado()}
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
          />
          <div className="card-background">
            <Spin spinning={this.state.loading}>
              <Form
                ref={this.formRef}
                name="productosAlCosto"
                layout
                bottom={
                  <div className="general-form-action-buttons">
                    <Space>
                      <ButtonItem
                        icon={<FilePdfOutlined />}
                        onClick={this.toggleModalPdf}
                        lilaB
                        hotkey="shift+v"
                      >
                        Ver PDF
                      </ButtonItem>
                      {this.state.estadoOrden === 1 && this.props.permisoEditarOrdenProductosAlCosto && (
                        <ButtonItem
                          ambarB
                          icon={<LockOutlined />}
                          onClick={() => this.abrirModalApartar('apartar')}
                        >
                          Apartar
                        </ButtonItem>
                      )}
                      {this.state.estadoOrden === 1 && this.state.ordenApartada && this.props.permisoEditarOrdenProductosAlCosto && (
                        <ButtonItem
                          negroB
                          icon={<UnlockOutlined />}
                          onClick={() => this.abrirModalApartar('desapartar')}
                        >
                          Desapartar
                        </ButtonItem>
                      )}
                      {this.state.estadoOrden === 1 && (
                        <Popconfirm
                          title={
                            "Seguro que quieres confirmar esta orden de productos al costo"
                          }
                          onConfirm={() => this.confirmarProductosAlCosto()}
                          okText="Si"
                          cancelText="No"
                        >
                          <ButtonItem verdeB hotkey="shift+a" type="primary">Confirmar</ButtonItem>
                        </Popconfirm>
                      )}
                      {this.state.estadoOrden === 1 && (
                        <Popconfirm
                          title={
                            "Seguro que quieres cancelar esta orden de productos al costo"
                          }
                          onConfirm={() => this.cancelarOrdenProductosAlCosto()}
                          okText="Si"
                          cancelText="No"
                        >
                          <ButtonItem hotkey="shift+c" type="primary" rojoB>
                            Cancelar
                          </ButtonItem>
                        </Popconfirm>
                      )}
                      <ButtonItem cyanB hotkey="shift+r" onClick={this.atras.bind(this)}>
                        Regresar
                      </ButtonItem>
                    </Space>
                  </div>
                }
              >
                  <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
                      <Col xs={24} lg={24} xl={24}>
                        <DynamicCardForm
                          title="DATOS GENERALES"
                          style={{ margin: 0, height: '100%' }}
                        >
                        <Row gutter={[12, 12]}>
                             <Col xs={24} lg={12}>
                              <FormItem label="Proyecto" name="proyectoId" margin required>
                                <SelectItem placeholder="Proyecto" noDisabledBackground disabled>
                                   {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                             </Col>
                             <Col xs={24} lg={12}>
                                <FormItem
                                  name="referencia"
                                  label="Referencia"
                                  margin
                                  pattern
                                >
                                    <InputItem disabled placeholder="Referencia" />
                                </FormItem>
                             </Col>
                        </Row>
                        </DynamicCardForm>
                      </Col>
                </Row>
                <div style={{ marginTop: 40 }}>
                  <TabbedDynamicTable
                    formInstance={this.formRef}
                    defaultActiveKey="insumos"
                    isMobile={isMobile}
                    tabs={allTabs}
                  />
                </div>
              </Form>
            </Spin>
          </div>
          <ModalProductosAlCostoPdf
            visible={this.state.modalPdfVisible}
            onCancel={this.toggleModalPdf}
            ordenId={this.props.location.state.id}
            ordenNumero={this.state.numOrden}
          />
          <ModalApartarProductosAlCosto
            visible={this.state.modalApartarVisible}
            modo={this.state.modalApartarModo}
            ordenId={this.props.location.state.id}
            ordenNumero={this.state.numOrden}
            cerrar={this.cerrarModalApartar.bind(this)}
          />
        </>
      );
    }
  }
  
  const mapStateToProps = (state) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
      // Apartar/Desapartar se gatean con el permiso de Editar la orden.
      permisoEditarOrdenProductosAlCosto:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a4d251bab8c795bc40e4a68"
      )?.activado,
    };
  };

  export default connect(mapStateToProps)(VerOrdenProductosAlCosto);